<template>
<div class="chapter">
<div class="inner_page">
<h1 class="p_heading_"><span class="calibre1">Erster Teil</span></h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0008.vue?e6b70ea8